import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from '@mui/material';
import NavBar from '../NavBar.js';
import { Footer } from '../Footer/Footer.js';
import { useLocation } from 'react-router-dom';
import { forgetPassword } from '../../actions/index.js';
import {
  codeNotReceived,
  FORGOT_PASSWORD_HEADER,
  resend,
  verificationCodeSentTo,
} from '../../constants/Forms';

import './ForgetPassword.css';

export const VerifyPassword = () => {
  const dispatch = useDispatch();
  const [resentMessage, setResentMessage] = useState('');
  const { state } = useLocation();

  const email = state?.email || '';

  const maskEmail = (email) => {
    const [username, domain] = email.split('@');
    const usernameMasked = username[0] + '*'.repeat(username.length - 1);
    return `${usernameMasked}@${domain}`;
  };

  const handleResendLink = () => {
    dispatch(forgetPassword({ email }));
    setResentMessage('Password link sent, please check your email.');
  };

  return (
    <>
      <NavBar currentPath="" />
      <div className="forget-password-wrapper">
        <header className="forget-password-header-wrapper">
          <div className="sign-up-log-in-image-wrapper">
            <img
              src="https://res.cloudinary.com/amunoali/image/upload/v1744215112/finance-auto-mortgage_lvbeob.png"
              className="sign-up-log-in-image"
            />
          </div>
          <form className="forget-password-form">
            <h5 className="forget-password-header">{FORGOT_PASSWORD_HEADER} </h5>
            {resentMessage && <p className="resentMessage">{resentMessage}</p>}

            <p className="forget-password-header-detail">{verificationCodeSentTo} </p>

            <div className="forget-password-input-wrapper">
              <p className="maskedEmail"> {maskEmail(email)}</p>
            </div>
            <div>
              <Link variant="outline" id="resendLink" onClick={handleResendLink}>
                {codeNotReceived} <strong>{resend}</strong>
              </Link>
            </div>
            <div></div>
          </form>
        </header>
      </div>
      <Footer currentPath={'/verify_password'} />
    </>
  );
};
